import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CountryService, Country, CntryBannerItemModel } from '../../../services/index';

@Component({
  selector: 'country-selector',
  templateUrl: 'country-selector.html'
})
export class CountrySelectorComponent {
  _selectedCntryCd:string;
  @Input() set selectedCntryCd(selectedCntryCd:string){
    if(!selectedCntryCd) return;
    this._selectedCntryCd = selectedCntryCd;
    this.checkInputCntry()
  }
  @Input() byCode: boolean = false;
  @Input() byCountry:boolean = false;

  get selectedCntryCd(){
    return this._selectedCntryCd;
  }

  @Input() except: Array<string>;
  @Output() onCountrySelect: EventEmitter<any> = new EventEmitter();

  selectedCntry: Country;
  countries: Array<Country> = [];
  countryList: Array<Country> = [];
  country: Country;
  isCntryListOpen:boolean = false;
  filteredCountryList: Array<Country> = [];
  focusedCntryIndex: number;


  @ViewChild("countryList")
  countryListElRef: ElementRef;

  countryControl: FormControl  = new FormControl();

  constructor(
    private countryService: CountryService,
  ) {
    
  }

  ngOnInit() {
    this.countries = this.countryService.countries;
    this.countryList = _.clone(this.countries);
    
    if(_.isEmpty(this.countries)) {

      this.countryService.countryListEe.subscribe(countries => {
        this.countries = countries;
        this.countryList = _.clone(countries);
        this.checkInputCntry();
      });
      if(!this.countryService.ingFlag){
        this.countryService.getCountries();
      }
    } else {
      this.checkInputCntry();
    }
  }

  checkInputCntry() {
    if(this.selectedCntryCd != null) {
      this.selectedCntry = _.find(this.countries, {cntryCd : this.selectedCntryCd});
      if(this.selectedCntry && !this.byCountry && !this.byCode) {
        this.countryControl.setValue(this.selectedCntry.cntryNm + ' (' + this.selectedCntry.cntryCd  +')');
      } else if(this.selectedCntry && this.byCountry && !this.byCode) {
        this.countryControl.setValue(this.selectedCntry.cntryNm);
      } else if(this.selectedCntry && !this.byCountry && this.byCode) {
        this.countryControl.setValue(this.selectedCntry.cntryCd);
      }
    }

    if(this.except != null && this.except.length == 1) {
      let exceptIndex = _.findIndex(this.countryList, {cntryCd: this.except});
      this.countryList.splice(exceptIndex, 1);  
    } else if(this.except != null && this.except.length > 1) {
      for(let country of this.except) {
        let exceptIndex = _.findIndex(this.countryList, {cntryCd: country});
        this.countryList.splice(exceptIndex, 1);
      };
    } else {
      return;
    }
  }

  setFilteredCountryList(event) {
    if (!event) return;
    
    let keyword = event.target.value;
    if (!keyword) {
      if (this.selectedCntry) this.selectedCntry = null;
      this.onCountrySelect.emit(null);
      this.isCntryListOpen = false;
      return;
    }

    if(keyword.length > 0) {
      keyword = _.toUpper(keyword.trim()).replace(/\s/g, '');
		  let filteredCountryList = _.map(_.filter(this.countryList,
																	(cntry) => {
																		if (keyword.length <= 0) return true;
																		else if (_.toUpper(cntry.cntryNm.trim()).replace(/\s/g, '').indexOf(keyword) >= 0) return true;
																		else if (_.upperCase(cntry.cntryCd).indexOf(keyword) >= 0) return true;
																		else return false;
                                  }));
      
      this.filteredCountryList = _.sortBy(filteredCountryList,
																(cntry) => {
                                  let nmIndex = _.toUpper(cntry.cntryNm.trim()).replace(/\s/g, '').indexOf(keyword);
                                  let cdIndex = _.upperCase(cntry.cntryCd).indexOf(keyword);

                                  if(this.byCode && !this.byCountry) {
                                    if (cdIndex < 0) cdIndex = 999;
                                    return cdIndex;
                                  } else {
                                    if (nmIndex < 0) nmIndex = 999;
                                    if (cdIndex < 0) cdIndex = 999;

                                    return _.min([nmIndex, cdIndex]);
                                  }
																});

      this.isCntryListOpen = true;
      this.focusedCntryIndex =  0;    
    } else {
      this.isCntryListOpen = false;
    }
  }

  handleKeyDown(event) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

		let suggestListDom = null;
		let focusedIndex = null;
		let type = null;

    suggestListDom = this.countryListElRef.nativeElement;
    focusedIndex = this.focusedCntryIndex;
    
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');


		switch (event.keyCode) {
			case 13: // enter
        if (_.isEmpty(this.filteredCountryList) || !this.focusedCntryIndex == null || !this.isCntryListOpen) return;
        let item = this.filteredCountryList[this.focusedCntryIndex];
        this.cntryListSelectHandler(item);
        this.isCntryListOpen = false;
			  break;
			case 27: // escape
					this.isCntryListOpen = false;
          
          if(this.selectedCntry && !this.byCountry && !this.byCode) {
            this.countryControl.setValue(this.selectedCntry.cntryNm + ' (' + this.selectedCntry.cntryCd  +')');
          } else if(this.selectedCntry && this.byCountry && !this.byCode) {
            this.countryControl.setValue(this.selectedCntry.cntryNm);
          } else if(this.selectedCntry && !this.byCountry && this.byCode) {
            this.countryControl.setValue(this.selectedCntry.cntryCd);
          }
          
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > suggestListItem.length - 1) focusedIndex = suggestListItem.length - 1;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        break;
			default: return;
    }	
    if (focusedIndex != this.focusedCntryIndex) this.focusedCntryIndex = focusedIndex;
    event.preventDefault();
  }

  handleCntryBlur($event) {
    if (this.isCntryListOpen) this.isCntryListOpen = false;

    if (this.selectedCntry && $event.target.value) {
      if(!this.byCountry && !this.byCode) {
        this.countryControl.setValue(this.selectedCntry.cntryNm + ' (' + this.selectedCntry.cntryCd  +')');
      } else if(this.byCountry && !this.byCode) {
        this.countryControl.setValue(this.selectedCntry.cntryNm);
      } else if(!this.byCountry && this.byCode) {
        this.countryControl.setValue(this.selectedCntry.cntryCd);
      }
    } else {
      this.countryControl.setValue(null);
    }
  }

  cntryListSelectHandler(cntry) {
    this.isCntryListOpen = false;
    this.selectedCntry = cntry;
    
    if(this.selectedCntry != null) {
      if(!this.byCountry && !this.byCode) {
        this.countryControl.setValue(this.selectedCntry.cntryNm + ' (' + this.selectedCntry.cntryCd  +')');
      } else if(this.byCountry && !this.byCode) {
        this.countryControl.setValue(this.selectedCntry.cntryNm);
      } else if(!this.byCountry && this.byCode) {
        this.countryControl.setValue(this.selectedCntry.cntryCd);
      }
      this.onCountrySelect.emit(this.selectedCntry);
    }  
    
  }

  setValue() {
    if(this.selectedCntry && this.selectedCntry.cntryNm && !this.byCode && !this.byCountry) {
      return this.selectedCntry.cntryNm + ' (' + this.selectedCntry.cntryCd + ')';
    } else if (this.selectedCntry && this.selectedCntry.cntryNm && this.byCode && !this.byCountry) {
      return this.selectedCntry.cntryCd;
    } else if (this.selectedCntry && this.selectedCntry.cntryNm && !this.byCode && this.byCountry) {
      return this.selectedCntry.cntryNm;
    } else {
    return '';
    }     
  }

  


}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/country-selector.ts